import React from 'react';

export default class MatchType extends React.Component{
    constructor(props){
        super(props);
        // this.state = {
        //     typeMatch: ''
        // }
    }

    // componentWillMount(){
    //     let state = {...this.state};
    //     state.typeMatch = "jornada"
    //     this.setState(state);
    //     console.log(state);
    // }

    render(){
        return(
            <select
                className="input"
                onChange={(e) => {
                    this.props.onChange(e.currentTarget.value)
                }}
            >
                <option selected={true}>Jornada</option>
                <option>Octavos</option>
                <option>Cuartos</option>
                <option>Semifinal</option>
                <option>Tercer Lugar</option>
                <option>Final</option>
                <option>Amistoso</option>
                {this.props.allTag && 
                    <option selected={true}>Todos</option>
                }
            </select>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/matchType/matchType.js